var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} /* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/explicit-module-boundary-types */
import { css } from "styled-components";
import PropTypes from "prop-types";
import { colorBrandBase, colorBrandLight, colorBrandDark, colorAccent, colorBlack, colorDarkest, colorDarker, colorDark, colorLight, colorLighter, colorLightest, colorNearWhite, colorWhite, colorHospital, colorExtras, colorCombined, colorHighlightBg, colorHighlightText, colorTrueGreen, colorTrueGreen80, colorTrueGreen60, colorTrueGreen40, colorTrueGreen20, colorBrightGreen, colorBrightGreen80, colorBrightGreen60, colorBrightGreen40, colorBrightGreen20, colorSunsetPink, colorSunsetPink80, colorSunsetPink60, colorSunsetPink40, colorSunsetPink20, colorWarmWhite, colorWarmWhite80, colorWarmWhite60, colorWarmWhite40, colorWarmWhite20, colorSageGreen, colorSageGreen80, colorSageGreen60, colorSageGreen40, colorSageGreen20, colorSuccess, colorInfo, colorError } from "@nib-components/theme";
import { map } from "../../breakpoint";
export var validNibColorValues = ["trueGreen", "trueGreen80", "trueGreen60", "trueGreen40", "trueGreen20", "brightGreen", "brightGreen80", "brightGreen60", "brightGreen40", "brightGreen20", "sageGreen", "sageGreen80", "sageGreen60", "sageGreen40", "sageGreen20", "sunsetPink", "sunsetPink80", "sunsetPink60", "sunsetPink40", "sunsetPink20", "warmWhite", "warmWhite80", "warmWhite60", "warmWhite40", "warmWhite20", "clearWhite", "deepBlack", "white", "black"];
export var validGenericColorValues = ["brandBase", "brandLight", "brandDark", "accent", "black", "darkest", "darker", "dark", "light", "lighter", "lightest", "nearWhite", "white", "hospital", "extras", "combined", "highlightBg", "highlightText", "transparent", "success", "info", "error", "warning"];
export var validColorValues = [].concat(validNibColorValues, validGenericColorValues);
export var pickColor = function pickColor(colorString) {
  switch (colorString) {
    case "trueGreen":
      return colorTrueGreen;
    case "trueGreen80":
      return colorTrueGreen80;
    case "trueGreen60":
      return colorTrueGreen60;
    case "trueGreen40":
      return colorTrueGreen40;
    case "trueGreen20":
      return colorTrueGreen20;
    case "brightGreen":
      return colorBrightGreen;
    case "brightGreen80":
      return colorBrightGreen80;
    case "brightGreen60":
      return colorBrightGreen60;
    case "brightGreen40":
      return colorBrightGreen40;
    case "brightGreen20":
      return colorBrightGreen20;
    case "sageGreen":
      return colorSageGreen;
    case "sageGreen80":
      return colorSageGreen80;
    case "sageGreen60":
      return colorSageGreen60;
    case "sageGreen40":
      return colorSageGreen40;
    case "sageGreen20":
      return colorSageGreen20;
    case "sunsetPink":
      return colorSunsetPink;
    case "sunsetPink80":
      return colorSunsetPink80;
    case "sunsetPink60":
      return colorSunsetPink60;
    case "sunsetPink40":
      return colorSunsetPink40;
    case "sunsetPink20":
      return colorSunsetPink20;
    case "warmWhite":
      return colorWarmWhite;
    case "warmWhite80":
      return colorWarmWhite80;
    case "warmWhite60":
      return colorWarmWhite60;
    case "warmWhite40":
      return colorWarmWhite40;
    case "warmWhite20":
      return colorWarmWhite20;
    case "clearWhite":
      return "#ffffff";
    case "deepBlack":
      return "#141414";
    case "brandBase":
      return colorBrandBase;
    case "brandLight":
      return colorBrandLight;
    case "brandDark":
      return colorBrandDark;
    case "accent":
      return colorAccent;
    case "black":
      return colorBlack;
    case "darkest":
      return colorDarkest;
    case "darker":
      return colorDarker;
    case "dark":
      return colorDark;
    case "light":
      return colorLight;
    case "lighter":
      return colorLighter;
    case "lightest":
      return colorLightest;
    case "nearWhite":
      return colorNearWhite;
    case "white":
      return colorWhite;
    case "success":
      return colorSuccess;
    case "info":
      return colorInfo;
    case "error":
      return colorError;
    case "warning":
      return "#ffb400";
    case "hospital":
      return colorHospital;
    case "extras":
      return colorExtras;
    case "combined":
      return colorCombined;
    case "highlightBg":
      return colorHighlightBg;
    case "highlightText":
      return colorHighlightText;
    case "transparent":
      return "transparent";
  }
};
export var background = function background(props) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref) {
    var background = _ref.background;
    return map(background, function (val) {
      return val !== undefined && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          background: ", ";\n        "])), pickColor(val));
    });
  });
};
export var color = function color(props) {
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref2) {
    var color = _ref2.color;
    return map(color, function (val) {
      return val !== undefined && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n          color: ", ";\n        "])), pickColor(val));
    });
  });
};
export var colorsPropType = PropTypes.oneOf(validColorValues);
export var colorsPropTypeMap = PropTypes.oneOfType([colorsPropType, PropTypes.shape({
  xs: colorsPropType,
  sm: colorsPropType,
  md: colorsPropType,
  lg: colorsPropType,
  xl: colorsPropType,
  xxl: colorsPropType,
  xxxl: colorsPropType
})]);